module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.12242/js/img/MarketingHub_Icon.svg"